import { makeStyles } from "@material-ui/core/styles";

export const useClassNames = makeStyles((theme) => ({
	content: {
		fontSize: "1.1rem",
		padding: theme.spacing(2)
	},
}));
